import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { MuiAutocompleteStyle } from '@/theme/components/MuiAutocomplete.style';
import { MuiButtonStyle } from './components/MuiButton.style';
import { MuiIconStyle } from './components/MuiIcon.style';
import { MuiMenuStyle } from './components/MuiMenu.style';
import { MuiMenuItemStyle } from './components/MuiMenuItem.style';
import { MuiAlertStyle } from './components/MuiAlert.style';
import { MuiSelectStyle } from './components/MuiSelect.style';
import { MuiStepConnectorStyle } from './components/MuiStepConnector.style';
import { MuiChipStyle } from './components/MuiChip.style';
import { MuiContainerStyle } from '@/theme/components/MuiContainer.style';
import { typography } from '@/theme/typography';
import { MuiTypographyStyle } from '@/theme/components/MuiTypography.style';
import { MuiSnackbarStyle } from '@/theme/components/MuiSnackbar.style';
import { Theme, alpha } from '@mui/material';

export { type Theme, alpha };

export const theme = createTheme({
  typography: typography,
  palette: palette,
  components: {
    MuiSnackbar: MuiSnackbarStyle,
    MuiAutocomplete: MuiAutocompleteStyle,
    MuiButton: MuiButtonStyle,
    MuiIcon: MuiIconStyle,
    MuiMenu: MuiMenuStyle,
    MuiMenuItem: MuiMenuItemStyle,
    MuiAlert: MuiAlertStyle,
    MuiSelect: MuiSelectStyle,
    MuiStepConnector: MuiStepConnectorStyle,
    MuiChip: MuiChipStyle,
    MuiContainer: MuiContainerStyle,
    MuiTypography: MuiTypographyStyle,
  },
  shape: {
    borderRadius: 4,
  },
  // See https://mui.com/material-ui/customization/breakpoints/#custom-breakpoints for reference
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
});
